import { render, staticRenderFns } from "./Venta.vue?vue&type=template&id=f3cde5b8&scoped=true"
import script from "./Venta.vue?vue&type=script&lang=js"
export * from "./Venta.vue?vue&type=script&lang=js"
import style0 from "./Venta.vue?vue&type=style&index=0&id=f3cde5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cde5b8",
  null
  
)

export default component.exports